import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';
import { GET_MARKET_PLACE_DETAILS, GET_PUBLIC_INFO } from 'redux/constants';

const apiStates = [
  ...restApiStates(['market-place'], 'marketPlace', true, true, true),
  { type: GET_PUBLIC_INFO, name: 'publicInfo' },
  { type: GET_MARKET_PLACE_DETAILS, name: 'marketPlaceDetails' },
];

const instantStates = [];
const storage = {};
const listValues = ['marketPlaces'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
